import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const FooterWrapper = styled.div`
  box-shadow: 0px -1px 2px 0px rgba(71, 71, 71, 0.04),
    0px -2px 4px 0px rgba(71, 71, 71, 0.08);
`;

export const FooterButtonWrapper = styled.div`
  display: flex;
  button {
    flex: 1;
    margin: 16px 20px;
    @media (min-width: ${breakpoints.md}) {
      margin: 20px 20px 12px;
    }
  }
`;
